// extracted by mini-css-extract-plugin
export default {"circle":"colorInputField_circle__OJDoh","selected":"colorInputField_selected__AK1-L"};